import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    background-color: #FFF;
    font-size: 12px;
    font-family: Roboto;
  }
  * {
    
  }
  sup {
    font-size: small;
    vertical-align: super;
  }
  div.tooltip{
    padding:1em;
    color: #666f75;
    background-color:rgba(255,255,255,.95);
    line-height:1.4;
  }
  svg .hilite{fill:transparent;transition:all .2s}
  :hover > svg .hilite{
    fill:#FE4438;
  }
  .pinpoint-tooltip {
    z-index: 2000 !important;
    line-height: 1.6;
    max-width: 32rem;
  }
`;
